// axios.js
import axios from "axios";
import qs from "qs";
import config from "../../config";


const $axios = axios.create({
  baseURL: config.baseUrl,
  timeout: 45000,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
});

// export const $json = axios.create({
//     baseURL: '/json',
//     timeout: 45000,
//     paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" })
// });

$axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || null;
  const lang = localStorage.getItem('lang') || 'ru';
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['Lang'] = lang;
  return config;
});

$axios.interceptors.response.use(
    (response) => response,
    (error) => {

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        console.log(error.response)
      }
      return Promise.reject(error);
    }
);

export default $axios;
